import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fenlei",
  "use": "icon-fenlei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fenlei\"><path fill=\"#333333\" d=\"M113.9 134.6H336v84H113.9zM113.9 479.8H336v84H113.9zM113.9 851.4h798.2v84H113.9zM651 578.4c-20.4 0-40.8-2.7-61-8.1-60.4-16.2-111-55-142.3-109.2-31.3-54.2-39.6-117.3-23.4-177.8 16.2-60.4 55-111 109.2-142.3 54.2-31.3 117.3-39.6 177.8-23.4 60.4 16.2 111 55 142.3 109.2 31.3 54.2 39.6 117.3 23.4 177.8-16.2 60.4-55 111-109.2 142.3-36.2 20.9-76.2 31.5-116.8 31.5z m-0.7-384.7c-26 0-51.7 6.8-74.9 20.2-34.8 20.1-59.6 52.5-70 91.3-10.4 38.8-5.1 79.3 15 114 27.8 48.2 78.4 75.1 130.4 75.1 25.5 0 51.3-6.5 74.9-20.1 34.8-20.1 59.6-52.5 70-91.3 10.4-38.8 5.1-79.3-15-114-20.1-34.8-52.5-59.6-91.3-70-12.9-3.5-26-5.2-39.1-5.2zM706.471 528.814l72.744-42 125.7 217.713-72.743 42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fenlei.svg
// module id = tQPi
// module chunks = 16